// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@par/app/core/services/config.service';
import { IabCategory } from '@par/app/shared/select-iab-category/models/iab-category-list-response';
import { IabCategoryListResponse } from '@par/app/core/model/dictionaries.response';

@Injectable({
  providedIn: 'root',
})
export class IabCategoryService {

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getIabCategories(): Observable<IabCategoryListResponse> {
    const url = this.configService.getConfig().kknowContentApi + '/iab-categories';
    return this.httpClient.get<IabCategory[]>(url).pipe(
      map((categories) => categories.map((category) => ({
        label: category.name,
        value: category.id,
      }))),
    );
  }
}
